<template>
    <modal v-bind="$attrs" :title="$t(title)" v-loading="loading" :visible.sync="isShowDialog" width="800px">
        <div class="hearContent">
            <el-form :model="dioForm" inline>
                <el-form-item :label="$t('public.time')">
                    <el-date-picker v-model="time" type="datetimerange" :start-placeholder="$t('public.start_date')"
                        :end-placeholder="$t('public.end_date')">
                    </el-date-picker>
                </el-form-item>
                <el-button icon="el-icon-search" @click="searchFn"></el-button>
            </el-form>
            <el-table stripe height="300px" :data="tableArray" style="width: 100%;margin-bottom: 20px;" row-key="id"
                :show-header="false">
                <el-table-column prop="createTime" show-overflow-tooltip>
                    <template #default="{ row }">
                        <span>{{ $timetransition(row.createTime) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="mac" show-overflow-tooltip />
                <el-table-column prop="ip" show-overflow-tooltip />
            </el-table>
            <Pagination class="pagination" :page.sync="dioForm.iDisplayStart" :limit.sync="dioForm.iDisplayLength"
                @pagination="getLogListFn" :total="total"></Pagination>
        </div>
        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
        </div>
    </modal>
</template>

<script>
import { gatewayhistoryList } from '@/api/modules/gateway.js'
export default {
    props: ['title', 'isShow', 'tableData', 'mac', 'totalAll'],
    computed: {
        isShowDialog: {
            get: function () {
                return this.isShow
            },
            set: function (val) {
                this.$emit('update:isShow', val);//可以优化成model  或者minx
            }
        },
    },
    watch: {
        tableData(newVal) {
            this.tableArray = [...newVal]
        },
        totalAll(newVal) {
            this.total = newVal
        }
    },
    data() {
        return {
            dioForm: {
                iDisplayStart: 0,
                iDisplayLength: 15,
                mac: null,
                startTime: null,
                endTime: null
            },
            time: [],
            total: 0,
            tableArray: [],
            loading: false
        }
    },
    methods: {
        searchFn() {
            this.getLogListFn()
        },
        getLogListFn() {
            if (this.time && this.time.length > 0) {
                if (this.time.length > 0) {
                    this.dioForm['startTime'] = this.$dateParseTime(this.time[0]);
                    this.dioForm['endTime'] = this.$dateParseTime(this.time[1]);
                }
            }
            this.dioForm.mac = this.mac;
            this.loading = true;
            gatewayhistoryList(this.dioForm).then(({ result }) => {
                this.tableArray = result['result']
                this.total = result['pageInfo'].total
            }).finally(() => this.loading = false)
        }
    }
}
</script>

<style lang="scss" scoped>
.hearContent {

    ::v-deep .el-button {
        background-color: #fff !important;

        i {
            color: var(--primary-color);
        }

        &:hover {
            background-color: var(--primary-color) !important;

            i {
                color: #fff;
            }
        }
    }
}

.pagination {
    padding-top: 0;
    padding-right: 15px !important;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
</style>